<template>
	<div class="full-height">
		<Header @menuChange="changeMenu"></Header>
		<div class="flex-center">
			<div class="main-container">
				<div class="nav-bar">
					<span>
						当前位置：
						<a href="/">首页</a>
						<span> > </span>
						<a href="#">史料研究</a>
						<span> > </span>
						<a href="/heroes">烈士事迹</a>
					</span>
				</div>

				<div class="flex" style="min-height: 765px;justify-content: center;width: 100%;">
					<div class="text-overflow-hidden detail-container flex" style="width: 100%;">
						<div class="menu-container">
							<a v-for="item in menus.children" :href="getMenuLink(item)">
								<div :class="{'menu-item-icontainer-active' : (nowMenuId == item.id), 'menu-item-container':true, 'flex-center' : true}">
									{{item.nameZh}}
								</div>
							</a>
						</div>

						<div class="full-width">

							<div style="float: right;margin-right: 10px;margin-bottom: 20px;">
								<el-input style="width: 250px;" placeholder="请输入烈士姓名" v-model="page.name" @clear="getData()" clearable>
								</el-input>
								<el-button type="danger" style="background: #A10000;" round @click="getData()">提交</el-button>
							</div>
							<div v-for="list in heroes" class="full-width flex">
								<a v-for="item in list" :href="'/detail/hero?id=' + item.id" style="width: 23%;display: inline-block;margin: 10px;">
									<div class="full-parent">
										<el-image :src="item.img" class="full-parent" style="height: 290px;"></el-image>
										<div class="hero-name">
											<p>{{item.name}}</p>
											<p style="margin-top: 10px;font-size: 16px;">{{item.bornYear + ' - ' + item.deadYear}}</p>
										</div>
									</div>
								</a>
							</div>
							<div style="width: 807px;margin-top: 20px;">
								<el-pagination background :page-size="page.size" layout="prev, pager, next" @current-change="changePage" :total="data.totalElements">
								</el-pagination>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '../../../components/Header';
	import Footer from '../../../components/Footer';
	import api from '../../../http/detail'
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				page: {
					page: 0,
					size: 12,
					sort: "id,desc",
					name: null
				},
				nowMenuId: 3,
				menus: {},
				data: {

				},
				heroes: [

				],
			}
		},
		methods: {
			getData() {
				const _this = this;
				api.getHeroes(this.page).then(res => {
					var outter = new Array()
					for (var i = 0; i < res.content.length; i += 4) {
						outter.push(res.content.slice(i, i + 4))
					}
					_this.heroes = outter
					_this.data = res;
				})
			},
			changeMenu(allMenus) {
				this.menus = allMenus.find(item => {
					if (item.id == 11) {
						return true;
					}
				});
				var menu = this.menus.children.find(item => {
					if (item.nameZh === "烈士事迹") {
						return true;
					}
				});
				this.nowMenuId = menu.id;
			},
			getMenuLink(item) {
				if (item.isOut == 1) {
					return item.url;
				}
				return '/detail?id=' + item.id + '&pid=' + item.parentId;
			},
			changePage(current) {
				this.page.page = current - 1;
				this.getData();
			}
		},
		created() {
			this.getData();
		},
		mounted() {

		}
	}
</script>

<style>
	.main-container {
		width: 1200px;
	}

	.nav-bar {
		text-align: left;
		width: 100%;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		margin: 23px 0;
	}

	.detail-container {
		margin: 23px 0 30px 30px;
		padding-right: 50pxs;
		width: 100%;
	}

	.menu-container {
		margin-right: 30px;
		background: #F7F7F7;
		height: fit-content;
	}

	.menu-item-container {
		width: 166px;
		height: 55px;
		color: #666666;
	}

	.menu-item-icontainer-active {
		background: #A10000;
		color: #FFFFFF !important;
	}

	.hero-name {
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
	}
</style>



// WEBPACK FOOTER //
// src/views/detail/hero/index.vue